import { ca } from '@cian/analytics';

export function trackPopupShow() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'banner_callnow',
    action: 'show_widget',
    label: 'JK',
    useLastProducts: true,
  });
}

export function trackPopupClose() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'banner_callnow',
    action: 'close',
    label: 'JK',
    useLastProducts: true,
  });
}

// Удалить в случае проигрыша эксперимента или переименовать в trackPopupShow в случае выигрыша в CD-164235.
export function trackPopupShowWithReasons() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'newbuilding_popup',
    action: 'show_sopr',
    label: 'ask_builder',
    useLastProducts: true,
  });
}

// Удалить в случае проигрыша эксперимента или переименовать в trackPopupClose в случае выигрыша в CD-164235.
export function trackPopupCloseWithReasons() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'newbuilding_popup',
    action: 'close_sopr',
    label: 'ask_builder',
    useLastProducts: true,
  });
}
